import RoleToolbar from "./toolbar.js";

export default RoleToolbar;

RoleToolbar.define()
